import URI from 'urijs'

export default class UrlManager {
  static addSearch(key, value) {
    let url = new URI(window.location.href)
    url.setSearch(key, value)
    history.pushState({}, '', url.toString())
  }
}
